import React from "react";
import {Link, useNavigate} from "react-router-dom";
import Badge from 'react-bootstrap/Badge';
import {theme} from "../MuiCustomization";
import {ThemeProvider} from "@mui/material";
import VehiclePrice from "./VehiclePrice";
import {LISTING_ALL_PAGE_TYPE, LISTING_MOTO_PAGE_TYPE, LISTING_ORDER_PAGE_TYPE} from "../Constants";
import VehicleTitle from "./VehicleTitle";
import VehicleAttributes from "./VehicleAttributes";

export default function VehicleListItem({vehicleObj, currencyExchangeRate, pageType}) {

    let navigate = useNavigate();
    const vehicleName = [vehicleObj.brand, vehicleObj.model, vehicleObj.configuration, vehicleObj.year]
        .filter(Boolean)
        .join(" ");

    function navigateVehicleView() {
        if (pageType === LISTING_ORDER_PAGE_TYPE) {
            navigate(`/vehicleOrder/catalog/${vehicleObj.id}`)
        } else if (pageType === LISTING_ALL_PAGE_TYPE) {
            navigate(`/listing/${vehicleObj.id}`)
        } else if (pageType === LISTING_MOTO_PAGE_TYPE) {
            navigate(`/catalog-moto/${vehicleObj.id}`)
        }
    }

    return (

        <div key={vehicleObj.id} className="col-md-6 col-lg-4 mb-4">
            <div className="listing d-block align-items-stretch">
                <ThemeProvider theme={theme}>
                    <div className="listing-img me-4 position-relative"
                         onClick={() => navigateVehicleView()}>
                        <h5 className="position-absolute top-0 end-0 m-1">
                            <Badge bg={vehicleObj.stockStatus === 'IN_STOCK' ? "success" : "secondary"}>
                                {vehicleObj.stockStatus === 'IN_STOCK' ? "В наличии" : "Под заказ"}
                            </Badge>
                        </h5>
                        <img src={vehicleObj.imageLinks[0]} className="img-fluid" alt={vehicleName}/>
                    </div>

                </ThemeProvider>

                <div className="listing-contents">
                    <h3 style={{cursor: 'pointer'}}
                        onClick={() => navigateVehicleView()}>
                        <VehicleTitle vehicle={vehicleObj} />
                    </h3>
                    <VehiclePrice price={vehicleObj.price} currencyExchangeRate={currencyExchangeRate}/>
                    <div className="d-flex flex-column mb-3 mt-2 border-bottom pb-3">
                        <VehicleAttributes
                            attributes={vehicleObj.vehicleAttributes}
                            onlyKeyAttributes={true}
                        />
                    </div>

                    <div className="row">
                        <div className="col-6">

                            <a className="btn btn-red p-2" onClick={() => navigateVehicleView()}>
                                <span className="icon-view_day"></span> Подробнее
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
}
